import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { toast } from 'sonner'
import App from './App'
import './app/globals.css'

// One-time migration: obelisk_* -> runara_* (user-visible storage keys)
if (typeof window !== 'undefined') {
  const migrate = (oldKey: string, newKey: string) => {
    const v = localStorage.getItem(oldKey)
    if (v && !localStorage.getItem(newKey)) {
      localStorage.setItem(newKey, v)
      localStorage.removeItem(oldKey)
    }
  }
  migrate('obelisk_auth_token', 'runara_auth_token')
  migrate('obelisk_last_username', 'runara_last_username')
  migrate('obelisk_last_password', 'runara_last_password')
}

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

// Add error handler for unhandled errors
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error)
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason)
  event.preventDefault()
  toast.error('Something went wrong. If the issue persists, try refreshing.')
})

try {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
} catch (error) {
  console.error('Failed to render app:', error)
  rootElement.innerHTML = `
    <div style="padding: 20px; font-family: monospace; color: red;">
      <h1>Failed to load application</h1>
      <pre>${error instanceof Error ? error.message : String(error)}</pre>
      <pre>${error instanceof Error ? error.stack : ''}</pre>
    </div>
  `
}